module.exports = __webpack_public_path__ + "static/media/CapabilitiesHero.12887b7a.png";